module.exports = __webpack_public_path__ + "static/media/logoWhite.3b720349.png";